import React from 'react';
import {observer} from 'mobx-react-lite';
import classNames from 'classnames';


import {IconProps} from "../../../../components/icons";


import {CheckBoxIcon} from "../../../../components/icons/CheckBoxIcon";


import './FieldWithCheckbox.css';


export interface FieldWithCheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: string;
    Icon: React.ComponentType<IconProps>;
}

export const FieldWithCheckbox = observer((
    {
        checked,
        onChange,
        label,
        Icon
    }: FieldWithCheckboxProps) => {
    return (
        <div className={classNames('FieldWithCheckbox')}>
            <CheckBoxIcon
                className={classNames({
                    'FieldWithCheckbox__CheckBox' : !checked,
                    'TaskList_checkbox_alt': checked })}
                isChecked={checked}
                onClick={() => onChange(!checked)}
                size={24}
            />
            <span className="FieldWithCheckbox__label body-large">
                {label}
            </span>
            <Icon className="FieldWithCheckbox__icon" size={24}/>
        </div>
    );
});
